module.exports = __webpack_public_path__ + "img/x341115a-63d2-42ce-8fe0-5f696ecdfca6.995189cf.jpg";